import { ZoningCodeService } from './../../../../services/zoning-code.service';
import { IProcessSettings } from '../../../../../../shared/interfaces/process-settings';
import { ZcVersionCalcProcessSettingsComponent } from '../../../dialogs/app-zc-version-calc-process-settings-dialog/app-zc-version-calc-process-settings-dialog.component';
import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { InstanceService, TaskService } from 'src/app/modules/instance/services';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';
import { IDetailsData } from 'src/app/shared/interfaces/details-data';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { IDialogDataLayers } from 'src/app/shared/interfaces/dialog-data-layers';
import { appSettings } from 'src/settings/config';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-calculate-with-settings-button',
    templateUrl: './zoning-code-version-calculate-with-settings-button.component.html',
    styleUrls: ['./zoning-code-version-calculate-with-settings-button.component.scss']
})
export class ZoningCodeVersionCalculateWithSettingsButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly dialog: MatDialog,
        private readonly instanceService: InstanceService,
        private readonly taskService: TaskService,
        private readonly zoningCodeService: ZoningCodeService
    ) {
        super();
    }

    @Input()
    public zoningCode: ZoningCode;

    @Input()
    public zoningCodeVersion: ZoningCodeVersion;

    @Input()
    public detailsData: IDetailsData;

    @Input()
    stateEnv: string;

    isOpenDialog = false;
    isDisabledLayers = true;

    public calculateZCVersion(processSettings: IProcessSettings) {
        if (!this.instanceService.selectedInstance || !this.zoningCodeVersion) {
            return;
        }

        if (this.isCalculating) {
            return;
        }

        this.taskService
            .calculateZCVersion(
                this.instanceService.selectedInstance.Id,
                this.zoningCodeVersion.Id,
                this.zoningCode.GridicsId,
                processSettings
            )
            .subscribe();
    }

    get isCalculating() {
        return this.zoningCodeVersion.CalculationTask && !this.zoningCodeVersion.CalculationTask.canStart;
    }

    openSetSettingsCalculateDialog(event: Event) {
        event.stopPropagation();
        this.zoningCodeService.getZoningCodeRecordById(this.zoningCode.Id, this.stateEnv, true).subscribe(cachedZC => {
            this.isDisabledLayers = this.zoningCodeVersion.hasTasks;
            const task = this.zoningCodeVersion.CalculationTask;
            const projectsDataSourceCategory = [_.get(cachedZC, 'ProjectsDataSourceCategory')].filter(dsc =>
                _.isNumber(dsc)
            );
            const dataSourceCategories = task ? task.dataSourceCategories : projectsDataSourceCategory;
            const maxPRsBunchSize = task ? task.maxPRsBunchSize : 1;
            const maxThreadsCount = task ? task.maxThreadsCount : 1;

            if (this.isOpenDialog) {
                return;
            }
            this.isOpenDialog = true;

            const dialogConfig = new MatDialogConfig();

            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                zcVersionId: this.zoningCodeVersion.Id,
                stateEnv: this.stateEnv,
                isCalculating: true,
                isReCalculating: false,
                isDisabledLayers: this.isDisabledLayers,
                dataSourceCategories,
                maxPRsBunchSize,
                maxThreadsCount,
                zoningCode: this.zoningCode,
                cachedZoningCode: cachedZC,
                useGAPIDataCache: _.isBoolean(_.get(task, 'useGAPIDataCache')) ? task.useGAPIDataCache : true,
                syncSolrData: task ? _.isBoolean(_.get(task, 'syncSolrData')) : appSettings.allowSyncSolrAUData
            } as IDialogDataLayers;
            dialogConfig.maxHeight = '850px';
            dialogConfig.width = '650px';
            dialogConfig.disableClose = true;

            this.dialog
                .open(ZcVersionCalcProcessSettingsComponent, dialogConfig)
                .afterClosed()
                .pipe(filter(isConfirm => isConfirm))
                .subscribe(value => {
                    this.calculateZCVersion(value);
                });
            this.isOpenDialog = false;
        });
    }
}
